import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/webp/logo-white.webp';
import _imports_1 from '@/assets/img/webp/logo.webp';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-cbb1de7e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "header-tool"
};
var _hoisted_2 = {
  key: 0,
  "class": "icon",
  src: _imports_0,
  alt: "aichiplink logo"
};
var _hoisted_3 = {
  key: 1,
  "class": "icon",
  src: _imports_1,
  alt: "aichiplink logo"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "line"
  }, null, -1);
});
var _hoisted_5 = {
  "class": "nav-wrapper"
};
var _hoisted_6 = {
  "class": "btns"
};
var _hoisted_7 = {
  "class": "avatar"
};
var _hoisted_8 = ["src"];
import { computed } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import Search from "./search.vue";
import NavMenu from "./nav-menu.vue";
import { useGlobalStore } from "@/store/global";
import { useUserStore } from "@/store/user";
export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: ["mode"],
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var showSearch = computed(function () {
      var isSearch = true;
      if (route.name === "search" || route.name === "category-sku") {
        isSearch = false;
      }
      return isSearch;
    });
    var store = useUserStore();
    var globalStore = useGlobalStore();
    var _storeToRefs = storeToRefs(globalStore),
      headerSearchIsShow = _storeToRefs.headerSearchIsShow,
      loginModalIsShow = _storeToRefs.loginModalIsShow,
      pageIsLoading = _storeToRefs.pageIsLoading;
    var isLogin = computed(function () {
      var _store$userInfo;
      return store === null || store === void 0 || (_store$userInfo = store.userInfo) === null || _store$userInfo === void 0 ? void 0 : _store$userInfo.userId;
    });
    var onClick = function onClick(type) {
      window.location.href = type;
      // setLoginModalIsShow(true, { status: type });
    };
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      var _component_a_flex = _resolveComponent("a-flex");
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_config_provider = _resolveComponent("a-config-provider");
      var _directive_track = _resolveDirective("track");
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["header", {
          shadow: _unref(headerSearchIsShow),
          white: props.mode === 'white'
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_link, {
        "class": "logo",
        to: {
          name: 'home'
        }
      }, {
        "default": _withCtx(function () {
          return [props.mode === 'white' ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3))];
        }),
        _: 1
      }), _hoisted_4, _createVNode(_component_a_flex, {
        flex: "1",
        gap: "40",
        justify: "space-between"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_a_flex, {
            align: "center",
            justify: "center",
            gap: "40",
            flex: "1"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_5, [_createVNode(NavMenu, {
                mode: props.mode
              }, null, 8, ["mode"])]), showSearch.value ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                "class": _normalizeClass(["search-panel", {
                  show: _unref(headerSearchIsShow)
                }])
              }, [_createVNode(Search, {
                mode: props.mode
              }, null, 8, ["mode"])], 2)) : _createCommentVNode("", true)];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_6, [isLogin.value ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: {
              name: 'user'
            }
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
                "class": "img",
                src: _unref(store).userInfo.avatar
              }, null, 8, _hoisted_8)])];
            }),
            _: 1
          })) : (_openBlock(), _createBlock(_component_a_flex, {
            key: 1,
            align: "center",
            justify: "center",
            gap: "middle"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_a_config_provider, {
                theme: {
                  token: {
                    colorPrimary: '#e7e8f8',
                    fontFamily: 'LineSeed'
                  }
                }
              }, {
                "default": _withCtx(function () {
                  return [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    size: "large",
                    type: "primary",
                    onClick: _cache[0] || (_cache[0] = function ($event) {
                      return onClick('login?source=/');
                    }),
                    "class": "login btn"
                  }, {
                    "default": _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.$t("Sign In")), 1)];
                    }),
                    _: 1
                  })), [[_directive_track, {
                    action: ['click', 'show'],
                    event: 'sign_in'
                  }]])];
                }),
                _: 1
              }), _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                size: "large",
                type: "primary",
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return onClick('signup?source=/');
                }),
                "class": "register btn"
              }, {
                "default": _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("Sign Up")), 1)];
                }),
                _: 1
              })), [[_directive_track, {
                action: ['click', 'show'],
                event: 'sign_up'
              }]])];
            }),
            _: 1
          }))])];
        }),
        _: 1
      })])], 2);
    };
  }
});